import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    const headers = { responseType: "arraybuffer" }

    return {
        relatorioUsuario(queryParms) {
            return repository.get(`${baseUrl}/relatorio-usuario?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioMaterial(queryParms) {
            return repository.get(`${baseUrl}/relatorio-material?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteBairro(queryParms) {
            return repository.get(`${baseUrl}/relatorio-paciente-bairro?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteConectaCidadao(queryParms) {
            return repository.get(`${baseUrl}/relatorio-paciente-conecta-cidadao?${urlUtil.serialize(queryParms)}`, headers)
        },
        pacienteFolhaRosto(id) {
            return repository.get(`${baseUrl}/paciente-folha-rosto/${id}`, headers)
        },
    }
}
